import { getQuotes } from './controller'

export const useQuotes = () => getQuotes()
